/**
 * Functions for finding elements in the DOM.
 *
 * @module
 */

/**
 * Array of matching elements
 *
 * @param {string} selector
 * @param {(Element|Document)} [context] Optional root of search. Defaults to document.
 * @return {Element[]} The list of matched elements.
 */
export function $$(selector, context = document) {
    return Array.from(context.querySelectorAll(selector));
}

/**
 * Find a matching ancestor.
 *
 * @param {Element} element The descendant from which to start looking up.
 * @param {string} selector
 * @param {Element} [stop] Ancestor at which matches become invalid, inclusive.
 * @return {(Element|null)} The first matched ancestor, if any.
 */
export function up(element, selector, stop = document.documentElement) {
    
    const anyAncestor = (() => {
        if (('closest' in HTMLElement.prototype) && element.parentElement) {
            return element.parentElement.closest(selector);
        }
        return $$(selector, stop).reverse().find(node => node.contains(element));
    })();
    return anyAncestor ? (stop.contains(anyAncestor) ? anyAncestor : null) : null;
}
